<template>
	<div>
		<div class="header-back"></div>
		<header>
			<div class="header-inner">
				<div class="header-inner__left">
					<router-link
						:to="
							$store.getters['auth/authData'].id
								? { name: 'mypage_index', params: { id: $store.getters['auth/authData'].id } }
								: { path: '/' }
						"
					>
						<img src="/images/logo_transparent_erp.png" />
					</router-link>
				</div>
				<div class="header-inner__middle" v-if="currentUserName">
					<!-- <button
						v-for="(link, i) in headerLinks"
						@click="renderPage(link.path, link.dep)"
						:id="link.id"
						:key="i"
						:class="headerLinkClass(link.id)"
						:disabled="$router.currentRoute.path == link.path"
					>
						{{ link.text }}
					</button> -->
					<v-select
						v-model="selectedDep"
						:items="headerLinks"
						item-text="text"
						item-value="value"
						label="部門選択"
						class="ma-1 w-300px"
						no-data-text="部門を選択してください"
						dense
						:hide-details="true"
						outlined
						return-object
						@change="renderPage(selectedDep.path, selectedDep.dep)"
					/>
					<v-btn color="primary" fab small @click="openMypage"
						><v-icon>mdi-account-box</v-icon></v-btn
					>
					<v-btn color="primary" fab small @click="openSetting"><v-icon>mdi-cog-box</v-icon></v-btn>
				</div>
				<v-row no-gutters justify="end" align="center" class="pr-lg-0 pr-16">
					<template v-if="currentUserName">
						<template v-if="messageCountError">
							<v-tooltip bottom v-model="showTip">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" @click="openMessageDialog" icon>
										<v-badge overlap color="red" dot
											><v-icon>mdi-bell-remove-outline</v-icon></v-badge
										>
									</v-btn>
								</template>
								<span
									>サーバーからの応答が途切れたため、受信できません。<br />ページをリロードすると改善する可能性があります。</span
								>
							</v-tooltip>
						</template>
						<div v-else @click="openMessageDialog" class="pointer">
							<v-badge overlap color="green" :content="messageCount.toString()"
								><v-icon>mdi-bell-outline</v-icon></v-badge
							>
						</div>
					</template>
				</v-row>
				<div class="header-inner__right">
					<p v-if="!currentUserName">
						ログイン
						<span>
							<a @click="redirectLogin">
								<i class="fas fa-sign-in-alt"></i>
							</a>
						</span>
					</p>
					<p v-else>
						ログイン： {{ currentUserName }} 様
						<span>
							<a @click.prevent="logout">
								<i class="fas fa-sign-out-alt"></i>
							</a>
						</span>
					</p>
				</div>
				<div class="btn-wrapper">
					<div
						:class="$vuetify.breakpoint.mdAndDown && showMenu ? 'open-btn active' : 'open-btn'"
						id="header-btn"
						@click="showMenu = !showMenu"
					>
						<span></span><span></span><span></span>
					</div>
				</div>
			</div>
			<div
				v-show="$vuetify.breakpoint.mdAndDown && showMenu"
				class="hamburger-links-wrapper"
				id="md-menu"
			>
				<div class="hamburger-links-inner">
					<p v-if="currentUserName">ログイン： {{ currentUserName }} 様</p>
					<button
						v-for="(link, i) in headerLinks"
						@click="renderPage(link.path, link.dep)"
						:id="link.id"
						:key="i"
						:class="headerLinkClass(link.id)"
					>
						{{ link.text }}
					</button>
					<!-- <router-link v-if="!currentUserName" :to="{ name: 'message_index' }">
						<v-badge overlap color="green" :content="messageCount == 0 ? '0' : messageCount"><v-icon>mdi-email-outline</v-icon></v-badge>
					</router-link> -->
					<a v-if="currentUserName" @click.prevent="logout" id="logout">ログアウト</a>
					<a v-else @click.prevent="redirectLogin" id="logout">ログイン</a>
				</div>
			</div>
		</header>
		<MessageDialog ref="message" v-if="currentUserName" />
	</div>
</template>

<script>
import MessageDialog from "../message/MessageDialog.vue"
export default {
	components: {
		MessageDialog,
	},
	data() {
		return {
			selectedDep: null,
			departments: this.$store.getters.departments,
			messageCount: this.$store.getters.messageCount,
			currentUserName: this.$store.getters["auth/authData"].full_name,
			messageCountError: false,
			showMenu: false,
			showTip: false,
			selectedPath: null,
		}
	},
	mounted() {
		this.$store.subscribe((mutation, _) => {
			if (mutation.type == "auth/updateAuthData") {
				this.currentUserName = this.$store.getters["auth/authData"].full_name
			} else if (mutation.type == "setMessageCount") {
				this.messageCount = this.$store.getters.messageCount
			} else if (mutation.type == "setDepartments") {
				this.departments = this.$store.getters.departments
			} else if (mutation.type == "reduceMessageCount") {
				this.messageCount = this.$store.getters.messageCount
			} else if (mutation.type == "clearMessageInterval") {
				this.messageCountError = this.$store.getters.messageCountError
			}
		})
		if (this.$store.getters.sideareaFlag == true) {
			this.selectedDep = this.$store.getters.selectedDepartment
		}
	},
	methods: {
		openMessageDialog() {
			this.$refs.message.openMessageDialog()
		},
		isEmpty(obj) {
			return !Object.keys(obj).length
		},
		redirectLogin() {
			this.$router.push({ name: "erp_login" })
		},
		logout() {
			this.$store.dispatch("auth/logOut")
			this.$store.commit("setFlash", {
				text: "ログアウトしました。",
				type: "notice",
			})
			this.redirectLogin()
			this.closeMenu()
		},
		closeMenu() {
			if (window.innerWidth < 1264) {
				var target = document.getElementById("header-btn")
				target.classList.remove("active")
				var open_target = document.getElementById("md-menu")
				open_target.classList.toggle("display-none")
			}
		},
		setHeaderPoint(text) {
			this.selectedLink = text
		},
		debug_console() {},
		renderPage(path, dep) {
			this.$router.push({ path, query: { id: dep.id, name: dep.name } })

			// if (dep != null) {
			// 	this.$store.commit("setSelectedDepartment", dep)
			// 	this.$store.commit("setSideareaFlag", true)
			// 	console.log(this.$store.state.selectedDepartment)
			// } else {
			// 	this.$store.commit("setSelectedDepartment", { id: "", name: "", features: [] })
			// 	console.log(this.$store.state.selectedDepartment)
			// 	this.$store.commit("setSideareaFlag", false)
			// }
			// this.showMenu = false
		},

		openMypage() {
			let mypagePath = "/users/" + this.$store.getters["auth/authData"].id + "/mypages"
			this.$router.push({ path: mypagePath })
			this.$store.commit("setSelectedDepartment", { id: "", name: "", features: [] })
		},
		openSetting() {
			this.$router.push({ path: "/erp/settings" })
			this.$store.commit("setSelectedDepartment", { id: "", name: "", features: [] })
		},
	},
	computed: {
		headerLinks() {
			const links = []
			// links.push({
			// 	path: "/users/" + this.$store.getters["auth/authData"].id + "/mypages",
			// 	id: "top",
			// 	text: "マイページ",
			// 	dep: null,
			// })
			this.departments.forEach((dep) => {
				links.push({
					path: `/feature_list`,
					id: dep.id,
					text: dep.name,
					dep: dep,
				})
			})
			// links.push({ path: "/erp/settings", id: "setting", text: "設定", dep: null })
			return links
		},
		headerLinkClass() {
			return (id) => {
				return this.selectedLink == id ? "selected" : null
			}
		},
	},
}
</script>

<style lang="scss" scoped>
$xs: 600px;
$sm: 960px;
$md: 1264px;
$lg: 1904px;
$xl: 1905px;
$space: 7px;
$main-color: #09194f;
$sub-color: #00808a;
$common-back-color: #fcfcfc;
$common-border-color: #ccc;
$common-font-color: #1a1a1a;
$border-line: solid 2px $main-color;
$gray-font-color: $sub-color;

.header-back {
	width: 100vw;
	height: 80px;
	@media (max-width: $md) {
		height: 70px;
	}
}
header {
	background: #fcfcfc;
	height: 80px;
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 100;
	box-shadow: 0 2px 4px gray;
	.header-inner {
		width: 100%;
		height: 100%;
		display: flex;
		&__left {
			height: 100%;
			width: 220px;
			padding-top: 14px;
			a,
			button {
				display: block;
			}
			img {
				width: 100%;
				max-height: 80%;
				display: block;
				object-fit: contain;
			}
		}
		&__middle {
			display: flex;
			align-items: center;
			justify-content: right;
			line-height: 80px;
			width: calc(100% - 300px - 300px);
			a,
			button {
				display: block;
				color: $common-font-color;
				&:hover {
					font-weight: bold;
					color: $main-color;
				}
			}
			a.selected,
			button.selected {
				font-weight: bold;
				position: relative;
				color: $main-color;
				&::after {
					content: "▼";
					position: absolute;
					transform: translate(-50%, -50%);
					top: 75%;
					left: 50%;
				}
			}
		}
		&__right {
			width: 300px;
			text-align: center;
			font-size: 14px;
			display: flex;
			justify-content: center;
			align-items: center;
			p {
				line-height: 100%;
				span {
					display: inline-block;
				}
				a,
				button {
					margin-left: 7px;
					color: $sub-color;
					&:hover {
						font-size: 120%;
					}
				}
			}
		}
	}
	@media (max-width: $md) {
		height: 70px;
		.header-inner {
			&__left {
				padding-top: 7px;
			}
			&__middle,
			&__right {
				display: none;
			}
			position: relative;
		}
	}
}

.btn-wrapper {
	position: absolute;
	top: 10px;
	right: 10px;
	display: none;
	@media (max-width: $md) {
		display: block;
	}
}
.open-btn {
	position: relative;
	cursor: pointer;
	width: 50px;
	height: 50px;
}

.open-btn span {
	display: inline-block;
	transition: all 0.4s;
	position: absolute;
	left: 14px;
	height: 2px;
	border-radius: 5px;
	background: $main-color;
	width: 45%;
}

.open-btn span:nth-of-type(1) {
	top: 13px;
}

.open-btn span:nth-of-type(2) {
	top: 19px;
}

.open-btn span:nth-of-type(3) {
	top: 25px;
}

.open-btn span:nth-of-type(3)::after {
	content: "MENU";
	position: absolute;
	top: 5px;
	left: -2px;
	color: $main-color;
	font-size: 0.6rem;
	text-transform: uppercase;
}

.open-btn.active span:nth-of-type(1) {
	top: 14px;
	left: 18px;
	transform: translateY(6px) rotate(-45deg);
	width: 30%;
}

.open-btn.active span:nth-of-type(2) {
	opacity: 0;
}

.open-btn.active span:nth-of-type(3) {
	top: 26px;
	left: 18px;
	transform: translateY(-6px) rotate(45deg);
	width: 30%;
}

.open-btn.active span:nth-of-type(3)::after {
	content: "Close";
	transform: translateY(0) rotate(-45deg);
	top: 5px;
	left: 4px;
}

.hamburger-links-wrapper {
	position: absolute;
	top: 70px;
	right: 0;
	width: 300px;
	z-index: 100;
	.hamburger-links-inner {
		background: #fcfcfc;
		padding: 14px;
		width: 100%;
		box-shadow: 0 2px 4px grey;
		border-bottom-left-radius: 5px;
		p {
			font-size: 14px;
			text-align: right;
		}
		a,
		button {
			font-size: 16px;
			display: block;
			color: $main-color;
			padding: 7px 4px;
			border-radius: 3px;
			transition: 200ms;
			width: 130px;
			text-align: left;
			&:hover {
				background: $main-color;
				color: white;
			}
		}
	}
}
.display-none {
	display: none !important;
}
.w-300px {
	width: 100%;
	max-width: 300px;
}
</style>
